export default __webpack_public_path__ + "static/media/driverSettingsGrey.041dbbbd.svg";